module.exports = __webpack_public_path__ + "static/product_sans_regular-webfont-acdbcd06057d4ca744c1674f6de91508.woff2";